import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientListComponent } from './client-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { SharedModule } from '../../shared/shared.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { ClientListFilterComponent } from './client-list-filter.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ClientListComponent, ClientListFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule,
    RouterModule
  ],
  exports: [ClientListComponent]
})
export class ClientListModule { }
